export default __webpack_public_path__ + "static/media/orientation.a978e501.png";